import styled from 'styled-components'

export const Container = styled.div`
  min-height: 100vh;
  display: grid;
  grid-template-rows: auto 1fr auto;
  overflow-x: hidden; /* Prevent horizontal scroll */
`

export const Content = styled.div`
  flex: 1 0 auto;
  display: flex;
  flex-direction: column;
  width: 100%;
`

export const MainContent = styled.main`
  flex: 1;
  padding: 0;
  width: 100%;
  min-height: 0; /* Important: allows flex child to shrink */
`

export const Footer = styled.footer`
  flex-shrink: 0;
  width: 100%;
  position: static; /* Ensure footer is in normal flow */
`

export const SpinnerContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`